import React from 'react';
import LandingNav from './components/LandingNav';
import LandingFooter from './components/LandingFooter';
import './landing.scss';

const TermsPage = () => (
  <div className="landing-page">
    <LandingNav />

    <div className="policy-hero">
      <div className="policy-hero-inner">
        <span className="policy-badge">Legal</span>
        <h1>Terms of Use</h1>
        <p className="policy-meta">Last updated June 01, 2026</p>
      </div>
    </div>

    <div className="policy-content">
      <div className="policy-inner">

        <h2>Agreement to Our Legal Terms</h2>
        <p>
          We are <strong>EPO POWER AND CONTROL TRADING</strong> ("Company," "we," "us," "our"). We operate{' '}
          <strong>manzilismart.com</strong>, as well as any other related products and services that refer or
          link to these legal terms (the "Legal Terms") (collectively, the "Services").
        </p>
        <p>
          You can contact us by email at <a href="mailto:info@manzilismart.com">info@manzilismart.com</a> or by
          mail to: 2nd Floor, Apartment No. 12, Building No. 76, Zone 27, Street No. 230, C-ring Road,
          Doha, Qatar 11926.
        </p>
        <p>
          These Legal Terms constitute a legally binding agreement made between you, whether personally or on
          behalf of an entity ("you"), and EPO POWER AND CONTROL TRADING, concerning your access to and use of
          the Services. You agree that by accessing the Services, you have read, understood, and agreed to be
          bound by all of these Legal Terms. <strong>IF YOU DO NOT AGREE WITH ALL OF THESE LEGAL TERMS, THEN
          YOU ARE EXPRESSLY PROHIBITED FROM USING THE SERVICES AND YOU MUST DISCONTINUE USE IMMEDIATELY.</strong>
        </p>
        <p>
          We reserve the right, in our sole discretion, to make changes or modifications to these Legal Terms at
          any time and for any reason. We will alert you about any changes by updating the "Last updated" date of
          these Legal Terms. It is your responsibility to periodically review these Legal Terms to stay informed
          of updates.
        </p>

        <div className="policy-toc">
          <h3>Table of Contents</h3>
          <ol>
            <li><a href="#t-1">Our Services</a></li>
            <li><a href="#t-2">Intellectual Property Rights</a></li>
            <li><a href="#t-3">User Representations</a></li>
            <li><a href="#t-4">Prohibited Activities</a></li>
            <li><a href="#t-5">Services Management</a></li>
            <li><a href="#t-6">Term and Termination</a></li>
            <li><a href="#t-7">Modifications and Interruptions</a></li>
            <li><a href="#t-8">Governing Law</a></li>
            <li><a href="#t-9">Dispute Resolution</a></li>
            <li><a href="#t-10">Corrections</a></li>
            <li><a href="#t-11">Disclaimer</a></li>
            <li><a href="#t-12">Limitations of Liability</a></li>
            <li><a href="#t-13">Indemnification</a></li>
            <li><a href="#t-14">User Data</a></li>
            <li><a href="#t-15">Electronic Communications</a></li>
            <li><a href="#t-16">Miscellaneous</a></li>
            <li><a href="#t-17">Contact Us</a></li>
          </ol>
        </div>

        <div className="policy-section" id="t-1">
          <h2>1. Our Services</h2>
          <p>
            The information provided when using the Services is not intended for distribution to or use by any
            person or entity in any jurisdiction or country where such distribution or use would be contrary to
            law or regulation or which would subject us to any registration requirement within such jurisdiction
            or country. Accordingly, those persons who choose to access the Services from other locations do so
            on their own initiative and are solely responsible for compliance with local laws, if and to the
            extent local laws are applicable.
          </p>
        </div>

        <div className="policy-section" id="t-2">
          <h2>2. Intellectual Property Rights</h2>
          <h3>Our intellectual property</h3>
          <p>
            We are the owner or the licensee of all intellectual property rights in our Services, including all
            source code, databases, functionality, software, website designs, audio, video, text, photographs,
            and graphics in the Services (collectively, the "Content"), as well as the trademarks, service marks,
            and logos contained therein (the "Marks").
          </p>
          <p>
            Our Content and Marks are protected by copyright and trademark laws and treaties around the world.
            The Content and Marks are provided in or through the Services "AS IS" for your personal,
            non-commercial use or internal business purpose only.
          </p>
          <h3>Your use of our Services</h3>
          <p>
            Subject to your compliance with these Legal Terms, we grant you a non-exclusive, non-transferable,
            revocable license to access the Services solely for your personal, non-commercial use or internal
            business purpose.
          </p>
          <p>
            Except as set out in this section, no part of the Services and no Content or Marks may be copied,
            reproduced, aggregated, republished, uploaded, posted, publicly displayed, encoded, translated,
            transmitted, distributed, sold, licensed, or otherwise exploited for any commercial purpose
            whatsoever, without our express prior written permission.
          </p>
          <p>
            Any breach of these Intellectual Property Rights will constitute a material breach of our Legal
            Terms and your right to use our Services will terminate immediately.
          </p>
          <h3>Your submissions</h3>
          <p>
            By directly sending us any question, comment, suggestion, idea, feedback, or other information about
            the Services ("Submissions"), you agree to assign to us all intellectual property rights in such
            Submission. You agree that we shall own this Submission and be entitled to its unrestricted use and
            dissemination for any lawful purpose, commercial or otherwise, without acknowledgment or compensation
            to you.
          </p>
        </div>

        <div className="policy-section" id="t-3">
          <h2>3. User Representations</h2>
          <p>By using the Services, you represent and warrant that:</p>
          <ul>
            <li>You have the legal capacity and you agree to comply with these Legal Terms;</li>
            <li>You are not a minor in the jurisdiction in which you reside;</li>
            <li>You will not access the Services through automated or non-human means, whether through a bot, script, or otherwise;</li>
            <li>You will not use the Services for any illegal or unauthorized purpose; and</li>
            <li>Your use of the Services will not violate any applicable law or regulation.</li>
          </ul>
          <p>
            If you provide any information that is untrue, inaccurate, not current, or incomplete, we have the
            right to suspend or terminate your account and refuse any and all current or future use of the Services.
          </p>
        </div>

        <div className="policy-section" id="t-4">
          <h2>4. Prohibited Activities</h2>
          <p>
            You may not access or use the Services for any purpose other than that for which we make the Services
            available. As a user of the Services, you agree not to:
          </p>
          <ul>
            <li>Systematically retrieve data or other content from the Services to create or compile a collection, compilation, database, or directory without written permission from us.</li>
            <li>Trick, defraud, or mislead us and other users, especially in any attempt to learn sensitive account information such as user passwords.</li>
            <li>Circumvent, disable, or otherwise interfere with security-related features of the Services.</li>
            <li>Use any information obtained from the Services in order to harass, abuse, or harm another person.</li>
            <li>Use the Services in a manner inconsistent with any applicable laws or regulations.</li>
            <li>Upload or transmit viruses, Trojan horses, or other malicious material that interferes with any party's uninterrupted use and enjoyment of the Services.</li>
            <li>Engage in any automated use of the system, such as using scripts to send comments or messages, or using any data mining, robots, or similar data gathering and extraction tools.</li>
            <li>Delete the copyright or other proprietary rights notice from any Content.</li>
            <li>Attempt to impersonate another user or person or use the username of another user.</li>
            <li>Interfere with, disrupt, or create an undue burden on the Services or the networks or services connected to the Services.</li>
            <li>Attempt to bypass any measures of the Services designed to prevent or restrict access to the Services, or any portion of the Services.</li>
            <li>Decipher, decompile, disassemble, or reverse engineer any of the software comprising or in any way making up a part of the Services.</li>
            <li>Make any unauthorized use of the Services, including collecting usernames and/or email addresses of users by electronic or other means for the purpose of sending unsolicited email.</li>
            <li>Use the Services as part of any effort to compete with us or otherwise use the Services and/or the Content for any revenue-generating endeavor or commercial enterprise.</li>
          </ul>
        </div>

        <div className="policy-section" id="t-5">
          <h2>5. Services Management</h2>
          <p>We reserve the right, but not the obligation, to:</p>
          <ul>
            <li>Monitor the Services for violations of these Legal Terms;</li>
            <li>Take appropriate legal action against anyone who, in our sole discretion, violates the law or these Legal Terms;</li>
            <li>In our sole discretion and without limitation, refuse, restrict access to, limit the availability of, or disable your access to the Services or any portion thereof;</li>
            <li>In our sole discretion and without limitation, notice, or liability, remove from the Services or otherwise disable all content that is excessive in size or is in any way burdensome to our systems; and</li>
            <li>Otherwise manage the Services in a manner designed to protect our rights and property and to facilitate the proper functioning of the Services.</li>
          </ul>
        </div>

        <div className="policy-section" id="t-6">
          <h2>6. Term and Termination</h2>
          <p>
            These Legal Terms shall remain in full force and effect while you use the Services.{' '}
            <strong>WITHOUT LIMITING ANY OTHER PROVISION OF THESE LEGAL TERMS, WE RESERVE THE RIGHT TO,
            IN OUR SOLE DISCRETION AND WITHOUT NOTICE OR LIABILITY, DENY ACCESS TO AND USE OF THE SERVICES
            (INCLUDING BLOCKING CERTAIN IP ADDRESSES), TO ANY PERSON FOR ANY REASON OR FOR NO REASON,
            INCLUDING WITHOUT LIMITATION FOR BREACH OF ANY REPRESENTATION, WARRANTY, OR COVENANT CONTAINED
            IN THESE LEGAL TERMS OR OF ANY APPLICABLE LAW OR REGULATION.</strong>
          </p>
          <p>
            If we terminate or suspend your account for any reason, you are prohibited from registering and
            creating a new account under your name, a fake or borrowed name, or the name of any third party.
            In addition to terminating or suspending your account, we reserve the right to take appropriate
            legal action, including without limitation pursuing civil, criminal, and injunctive redress.
          </p>
        </div>

        <div className="policy-section" id="t-7">
          <h2>7. Modifications and Interruptions</h2>
          <p>
            We reserve the right to change, modify, or remove the contents of the Services at any time or for
            any reason at our sole discretion without notice. We will not be liable to you or any third party
            for any modification, price change, suspension, or discontinuance of the Services.
          </p>
          <p>
            We cannot guarantee the Services will be available at all times. We may experience hardware,
            software, or other problems or need to perform maintenance related to the Services, resulting in
            interruptions, delays, or errors. You agree that we have no liability whatsoever for any loss,
            damage, or inconvenience caused by your inability to access or use the Services during any downtime
            or discontinuance of the Services.
          </p>
        </div>

        <div className="policy-section" id="t-8">
          <h2>8. Governing Law</h2>
          <p>
            These Legal Terms shall be governed by and defined following the laws of <strong>Qatar</strong>.
            EPO POWER AND CONTROL TRADING and yourself irrevocably consent that the courts of{' '}
            <strong>Qatar</strong> shall have exclusive jurisdiction to resolve any dispute which may arise in
            connection with these Legal Terms.
          </p>
        </div>

        <div className="policy-section" id="t-9">
          <h2>9. Dispute Resolution</h2>
          <h3>Informal Negotiations</h3>
          <p>
            To expedite resolution and control the cost of any dispute, controversy, or claim related to these
            Legal Terms, the Parties agree to first attempt to negotiate any Dispute informally for at least{' '}
            <strong>thirty (30) days</strong> before initiating arbitration. Such informal negotiations commence
            upon written notice from one Party to the other Party.
          </p>
          <h3>Binding Arbitration</h3>
          <p>
            If the parties are unable to resolve the dispute through informal negotiation, the dispute shall be
            finally resolved by arbitration in accordance with the United Nations Commission on International
            Trade Law Arbitration Rules in force at the time of commencement of the arbitration. The number of
            arbitrators shall be <strong>one (1)</strong>. The seat, or legal place, of arbitration shall be{' '}
            <strong>Doha, Qatar</strong>. The language of the proceedings shall be <strong>English</strong>.
            The governing law of these Legal Terms shall be the substantive law of <strong>Qatar</strong>.
          </p>
          <h3>Restrictions</h3>
          <p>
            The Parties agree that any arbitration shall be limited to the Dispute between the Parties
            individually. To the full extent permitted by law: (a) no arbitration shall be joined with any
            other proceeding; (b) there is no right or authority for any Dispute to be arbitrated on a
            class-action basis; and (c) there is no right or authority for any Dispute to be brought in a
            purported representative capacity on behalf of the general public or any other persons.
          </p>
          <h3>Exceptions to Informal Negotiations and Arbitration</h3>
          <p>
            The Parties agree that the following Disputes are not subject to the above provisions concerning
            informal negotiations and binding arbitration: (a) any Disputes seeking to enforce or protect, or
            concerning the validity of, any of the intellectual property rights of a Party; (b) any Dispute
            related to, or arising from, allegations of theft, piracy, invasion of privacy, or unauthorized
            use; and (c) any claim for injunctive relief.
          </p>
        </div>

        <div className="policy-section" id="t-10">
          <h2>10. Corrections</h2>
          <p>
            There may be information on the Services that contains typographical errors, inaccuracies, or
            omissions, including descriptions, pricing, availability, and various other information. We reserve
            the right to correct any errors, inaccuracies, or omissions and to change or update the information
            on the Services at any time, without prior notice.
          </p>
        </div>

        <div className="policy-section" id="t-11">
          <h2>11. Disclaimer</h2>
          <p>
            <strong>THE SERVICES ARE PROVIDED ON AN AS-IS AND AS-AVAILABLE BASIS. YOU AGREE THAT YOUR USE OF
            THE SERVICES WILL BE AT YOUR SOLE RISK. TO THE FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM ALL
            WARRANTIES, EXPRESS OR IMPLIED, IN CONNECTION WITH THE SERVICES AND YOUR USE THEREOF, INCLUDING,
            WITHOUT LIMITATION, THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
            AND NON-INFRINGEMENT. WE MAKE NO WARRANTIES OR REPRESENTATIONS ABOUT THE ACCURACY OR COMPLETENESS
            OF THE SERVICES' CONTENT AND WE WILL ASSUME NO LIABILITY OR RESPONSIBILITY FOR ANY ERRORS,
            MISTAKES, OR INACCURACIES OF CONTENT AND MATERIALS, PERSONAL INJURY OR PROPERTY DAMAGE OF ANY
            NATURE WHATSOEVER RESULTING FROM YOUR ACCESS TO AND USE OF THE SERVICES, ANY UNAUTHORIZED ACCESS
            TO OR USE OF OUR SECURE SERVERS AND/OR ANY AND ALL PERSONAL INFORMATION STORED THEREIN, ANY
            INTERRUPTION OR CESSATION OF TRANSMISSION TO OR FROM THE SERVICES, OR ANY BUGS, VIRUSES, TROJAN
            HORSES, OR THE LIKE WHICH MAY BE TRANSMITTED TO OR THROUGH THE SERVICES BY ANY THIRD PARTY.</strong>
          </p>
        </div>

        <div className="policy-section" id="t-12">
          <h2>12. Limitations of Liability</h2>
          <p>
            <strong>IN NO EVENT WILL WE OR OUR DIRECTORS, EMPLOYEES, OR AGENTS BE LIABLE TO YOU OR ANY THIRD
            PARTY FOR ANY DIRECT, INDIRECT, CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, SPECIAL, OR PUNITIVE
            DAMAGES, INCLUDING LOST PROFIT, LOST REVENUE, LOSS OF DATA, OR OTHER DAMAGES ARISING FROM YOUR
            USE OF THE SERVICES, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
            NOTWITHSTANDING ANYTHING TO THE CONTRARY CONTAINED HEREIN, OUR LIABILITY TO YOU FOR ANY CAUSE
            WHATSOEVER AND REGARDLESS OF THE FORM OF THE ACTION, WILL AT ALL TIMES BE LIMITED TO THE LESSER
            OF THE AMOUNT PAID, IF ANY, BY YOU TO US IN THE TWELVE (12) MONTHS PRECEDING THE CLAIM OR ONE
            HUNDRED US DOLLARS (USD 100.00).</strong>
          </p>
        </div>

        <div className="policy-section" id="t-13">
          <h2>13. Indemnification</h2>
          <p>
            You agree to defend, indemnify, and hold us harmless, including our subsidiaries, affiliates, and
            all of our respective officers, agents, partners, and employees, from and against any loss, damage,
            liability, claim, or demand, including reasonable attorneys' fees and expenses, made by any third
            party due to or arising out of: (1) use of the Services; (2) breach of these Legal Terms; (3) any
            breach of your representations and warranties set forth in these Legal Terms; (4) your violation of
            the rights of a third party, including but not limited to intellectual property rights; or (5) any
            overt harmful act toward any other user of the Services with whom you connected via the Services.
          </p>
        </div>

        <div className="policy-section" id="t-14">
          <h2>14. User Data</h2>
          <p>
            We will maintain certain data that you transmit to the Services for the purpose of managing the
            performance of the Services, as well as data relating to your use of the Services. Although we
            perform regular routine backups of data, you are solely responsible for all data that you transmit
            or that relates to any activity you have undertaken using the Services. You agree that we shall have
            no liability to you for any loss or corruption of any such data, and you hereby waive any right of
            action against us arising from any such loss or corruption of such data.
          </p>
        </div>

        <div className="policy-section" id="t-15">
          <h2>15. Electronic Communications, Transactions, and Signatures</h2>
          <p>
            Visiting the Services, sending us emails, and completing online forms constitute electronic
            communications. You consent to receive electronic communications, and you agree that all agreements,
            notices, disclosures, and other communications we provide to you electronically, via email and on
            the Services, satisfy any legal requirement that such communication be in writing. You hereby agree
            to the use of electronic signatures, contracts, orders, and other records, and to electronic
            delivery of notices, policies, and records of transactions initiated or completed by us or via the
            Services.
          </p>
        </div>

        <div className="policy-section" id="t-16">
          <h2>16. Miscellaneous</h2>
          <p>
            These Legal Terms and any policies or operating rules posted by us on the Services constitute the
            entire agreement and understanding between you and us. Our failure to exercise or enforce any right
            or provision of these Legal Terms shall not operate as a waiver of such right or provision. These
            Legal Terms operate to the fullest extent permissible by law. We may assign any or all of our rights
            and obligations to others at any time. If any provision or part of a provision of these Legal Terms
            is determined to be unlawful, void, or unenforceable, that provision or part of the provision is
            deemed severable from these Legal Terms and does not affect the validity and enforceability of any
            remaining provisions. There is no joint venture, partnership, employment, or agency relationship
            created between you and us as a result of these Legal Terms or use of the Services.
          </p>
        </div>

        <div className="policy-section" id="t-17">
          <h2>17. Contact Us</h2>
          <p>In order to resolve a complaint regarding the Services or to receive further information regarding use of the Services, please contact us at:</p>
          <address>
            EPO POWER AND CONTROL TRADING<br />
            2nd Floor, Apartment No. 12, Building No. 76<br />
            Zone 27, Street No. 230, C-ring Road<br />
            Doha, Qatar 11926<br />
            Email: <a href="mailto:info@manzilismart.com">info@manzilismart.com</a>
          </address>
        </div>

      </div>
    </div>

    <LandingFooter />
  </div>
);

export default TermsPage;
